import { render, staticRenderFns } from "./ReportCardDoughnutChart.vue?vue&type=template&id=2b8e0c98"
import script from "./ReportCardDoughnutChart.vue?vue&type=script&lang=ts"
export * from "./ReportCardDoughnutChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports